import * as React from 'react';

import {FieldArray} from 'redux-form';

import {FormField} from 'shells/form/form-field';

import {PipelineFields} from './pipeline-fields';

export function LeadStageEnteredForm() {
    return (
        <FormField innerId='stageEntered' label='Which pipeline?'>
            <FieldArray
                name='stageEntered'
                rerenderOnEveryChange={true}
                component={PipelineFields}
                formType='stageEntered'
            />
        </FormField>
    );
}
